// tslint:disable no-console
import { Core } from './Constants';
import * as FetchUtil from './FetchUtil';
import { merge } from './helpers/MergeHeaders';
import { create } from './HydraResponse';
const getHydraResponse = async (alcaeus, response, uri, apiDocumentation) => {
    const suitableProcessor = Object.values(alcaeus.mediaTypeProcessors)
        .find((processor) => processor.canProcess(response.mediaType));
    if (suitableProcessor) {
        const graph = await suitableProcessor.process(alcaeus, uri, response, apiDocumentation);
        return create(uri, response, graph, alcaeus.rootSelectors);
    }
    console.warn(`No processor found for media type ${response.mediaType}`);
    return create(uri, response);
};
function getApiDocumentation(response, headers) {
    if (response.apiDocumentationLink) {
        return this.loadDocumentation(response.apiDocumentationLink, headers);
    }
    else {
        console.warn(`Resource ${response.requestedUri} does not expose API Documentation link`);
        return Promise.resolve(null);
    }
}
export class Alcaeus {
    constructor(rootSelectors, mediaTypeProcessors) {
        this.defaultHeaders = {};
        this.rootSelectors = rootSelectors;
        this.mediaTypeProcessors = mediaTypeProcessors;
    }
    async loadResource(uri, headers = {}) {
        const response = await FetchUtil.fetchResource(uri, this.__mergeHeaders(new Headers(headers)));
        const apiDocumentation = await getApiDocumentation.call(this, response, headers);
        if (apiDocumentation) {
            return getHydraResponse(this, response, uri, apiDocumentation);
        }
        return getHydraResponse(this, response, uri);
    }
    async loadDocumentation(uri, headers = {}) {
        try {
            const response = await FetchUtil.fetchResource(uri, this.__mergeHeaders(new Headers(headers)));
            const representation = await getHydraResponse(this, response, uri);
            const resource = representation.root;
            if (!resource) {
                console.warn('Could not determine root resource');
                return null;
            }
            const resourceType = resource['@type'];
            let resourceHasApiDocType;
            if (Array.isArray(resourceType)) {
                resourceHasApiDocType = resourceType.includes(Core.Vocab('ApiDocumentation'));
            }
            else {
                resourceHasApiDocType = resourceType === Core.Vocab('ApiDocumentation');
            }
            if (resourceHasApiDocType === false) {
                console.warn(`The resource ${uri} does not appear to be an API Documentation`);
            }
            return resource;
        }
        catch (e) {
            console.warn(`Failed to load ApiDocumentation from ${uri}`);
            console.warn(e);
            console.warn(e.stack);
            return null;
        }
    }
    async invokeOperation(operation, uri, body, headers = {}) {
        if (typeof headers === 'string') {
            headers = {
                'content-type': headers,
            };
            // TODO: remove in 1.0
            console.warn('DEPRECATION NOTICE: passing content type as string will be removed in version 1.0');
        }
        const mergedHeaders = this.__mergeHeaders(new Headers(headers));
        const response = await FetchUtil.invokeOperation(operation.method, uri, body, mergedHeaders);
        const apiDocumentation = await getApiDocumentation.call(this, response, mergedHeaders);
        if (apiDocumentation) {
            return getHydraResponse(this, response, uri, apiDocumentation);
        }
        return getHydraResponse(this, response, uri);
    }
    __mergeHeaders(headers) {
        const defaultHeaders = typeof this.defaultHeaders === 'function' ? this.defaultHeaders() : this.defaultHeaders;
        return merge(new Headers(defaultHeaders), headers);
    }
}
//# sourceMappingURL=alcaeus.js.map